import { useMutation } from "@apollo/client";
import { Modal, PasswordInput, Button, Group } from "@mantine/core";
import { useForm } from "@mantine/form";
import { showNotification } from "@mantine/notifications";
import { CHANGE_PASSWORD } from "apollo/mutuations";

export default function ChangePasswordModal({ opened, onClose }) {
  const form = useForm({
    initialValues: {
      current_password: "",
      password: "",
      password_confirmation: "",
    },
    validate: {
      password: (value) =>
        value.length < 6 ? "Password must be at least 6 characters" : null,
      password_confirmation: (value, values) =>
        value !== values.password ? "Passwords do not match" : null,
    },
  });
  const [changePassword, { loading }] = useMutation(CHANGE_PASSWORD);

  const submit = () => {
    const variables = {
      current_password: form.values.current_password,
      password: form.values.password,
      password_confirmation: form.values.password_confirmation,
    };

    changePassword({
      variables,
      onCompleted(data) {
        showNotification({
          color: "green",
          title: "Success",
          message: "Password Changed Successfully",
        });

        onClose();
      },
      onError(error) {
        showNotification({
          color: "red",
          title: "Error",
          message:
            error?.graphQLErrors?.[0]?.message || "Failed to Change Password",
        });
      },
    });
  };
  return (
    <Modal opened={opened} onClose={onClose} centered>
      <form onSubmit={form.onSubmit(submit)}>
        <PasswordInput
          label="Current Password"
          {...form.getInputProps("current_password")}
          required
          mb="sm"
        />
        <PasswordInput
          label="New Password"
          {...form.getInputProps("password")}
          required
          mb="sm"
        />
        <PasswordInput
          label="Confirm New Password"
          {...form.getInputProps("password_confirmation")}
          required
          mb="sm"
        />

        <Group position="right" mt="lg">
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button
            type="submit"
            loading={loading}
            style={{
              backgroundColor: "#FF6A00",
              color: "#FFFFFF",
            }}
          >
            Change Password
          </Button>
        </Group>
      </form>
    </Modal>
  );
}
